import React, { PropsWithChildren } from "react";
import { Box } from "@mui/material";
import MainLayout from "../main/main_layout";

export default function MerchantLayout({ children }: PropsWithChildren) {
  return (
    <MainLayout>
      <Box sx={{ flexGrow: 1, p: 3 }}>
        {children}
      </Box>
    </MainLayout>
  );
}